export const LOGIN = 'saga/Auth/LOGIN'
export const LOGIN_SUCCESS = 'saga/Auth/LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'saga/Auth/LOGIN_FAILURE'
export const USER_TOS_DOCS = 'saga/Auth/USER_TOS_DOCS'
export const ACCEPT_DOC = 'saga/Auth/ACCEPT_TOS_DOC'
export const ACCEPT_DOC_SUCCESS = 'saga/Auth/ACCEPT_TOS_SUCCESS'
export const ACCEPT_DOC_FAILURE = 'saga/Auth/ACCEPT_TOS_FAILURE'
export const actions = {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  USER_TOS_DOCS,
  ACCEPT_DOC,
  ACCEPT_DOC_SUCCESS,
  ACCEPT_DOC_FAILURE
}



// WEBPACK FOOTER //
// ./src/redux/sagas/auth/actions.js